import { HAZARD_FIELD } from './constants';

export const HAZARD_RECORD_REQUIRED_KEYS = new Set<string>([
  HAZARD_FIELD.category,
  HAZARD_FIELD.whoMightBeHarmed,
  HAZARD_FIELD.howMightBeHarmed,
]);
